import { lazy } from 'react';

const OutgoingView = lazy(() => import('./OutgoingView'));

export default OutgoingView;
